module.exports = __webpack_public_path__ + "img/copy1.dba540ed.svg";